/**
 * Module type of the source files in a package.
 */
export type ModuleType = 'cjs' | 'esm' | 'amd';
